<!-- TABLE Ở TRANG ADMIN -->
<nz-layout id="purchase-invoice-today">
  <!-- Phần header -->
  <div class="purchase-invoice-today-header">
    <div class="row p-0 m-0">
      <div class="col-4 p-0 m-0 d-flex align-items-center">

      </div>
      <div class="col-4 p-0 m-0 d-flex align-items-center justify-content-center">
        <!-- Chọn thiết bị -->
        <div *ngIf="showChooseDevice" class="device">
          <div *ngIf="subproject.desktop_template_display && subproject?.style !== 'app'" class="icon-field p-2"
            role="button" [class.active]="deviceTemp == 'desktop'" (click)="deviceTemp = 'desktop'">
            <span nz-icon [nzType]="'desktop'" nzTheme="outline" data-toggle="tooltip" [title]="'desktop'" nz-tooltip
              nzTooltipTitle="{{'may_tinh' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.tablet_landscape_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'tablet_landscape'" (click)="deviceTemp = 'tablet_landscape'">
            <span nz-icon style="transform: rotate(90deg); scale: 1.2" [nzType]="'tablet'" nzTheme="outline"
              data-toggle="tooltip" [title]="'tablet'" nz-tooltip nzTooltipTitle="{{'may_tinh_bang_ngang' | translate}}"
              nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.tablet_portrait_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'tablet_portrait'" (click)="deviceTemp = 'tablet_portrait'">
            <span nz-icon style="scale: 1.2" [nzType]="'tablet'" nzTheme="outline" data-toggle="tooltip"
              [title]="'tablet'" nz-tooltip nzTooltipTitle="{{'may_tinh_bang_doc' | translate}}"
              nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.mobile_landscape_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'mobile_landscape'" (click)="deviceTemp = 'mobile_landscape'">
            <span nz-icon style="transform: rotate(90deg)" [nzType]="'mobile'" nzTheme="outline" data-toggle="tooltip"
              [title]="'mobile'" nz-tooltip nzTooltipTitle="{{'dien_thoai_ngang' | translate}}"
              nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.mobile_portrait_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'mobile_portrait'" (click)="deviceTemp = 'mobile_portrait'">
            <span nz-icon [nzType]="'mobile'" nzTheme="outline" data-toggle="tooltip" [title]="'mobile'" nz-tooltip
              nzTooltipTitle="{{'dien_thoai_doc' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
        </div>
      </div>
      <!-- Nút thêm sản phẩm vào frame -->
      <div class="col-4 p-0 m-0 d-flex align-items-center justify-content-end">
        <!-- Chọn ngôn ngữ -->
        <div class="mr-2">
          <app-select-language-config [isAdmin]="true"></app-select-language-config>
        </div>
        <button nzType="primary" class="_btn _btn_add d-flex align-items-center right-all-content mr-2" nz-button
          (click)="handleAddData()">
          {{
          'them_du_lieu' | translate
          }}
        </button>
      </div>
    </div>
  </div>
  <!-- Phần table -->
  <div style="margin-top: 16px; height: 500px">
    <nz-table #editRowTable nzBordered [nzData]="listOfData" [nzLoading]="loading" [nzTotal]="total" nzShowSizeChanger
      [nzPageSizeOptions]="[5, 10, 20, 50]" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
      [nzScroll]="{ y: '400px' }">
      <thead>
        <tr>
          <th nzWidth="10%">{{'STT' | translate}}</th>
          <th nzWidth="80%">{{'doi_tuong' | translate}}</th>
          <th nzWidth="10%">{{'thao_tac'| translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dataRow of editRowTable.data">
          <td>
            <div class="editable-cell" [hidden]="itemEdit?._id === dataRow._id" (click)="itemEdit = dataRow;">
              {{ dataRow.sort }}
            </div>
            <input [hidden]="itemEdit?._id !== dataRow._id" type="text" nz-input [(ngModel)]="dataRow.sort"
              (blur)="updateOrdinal(dataRow)" />
          </td>

          <td>
            <ng-container *ngFor="let item of dataRow.data">
              <ng-container *ngIf="item.type == 'image-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>:
                  <img width="100px" height="100px" [src]="item[deviceTemp + '_value'] || item.value" alt="image-repeat"
                    class="mb-2 item-img" />
                  <!-- Mô tả nội dung của ảnh -->
                  <strong class="item-name ml-4">{{ 'mo_ta' | translate }}</strong>
                  : {{ item['accessibility_alt_' + functionService.languageTempCode] || 'Ảnh' }}
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'text-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>: {{ item['value_' +
                  functionService.languageTempCode] | vhLanguage : 'value' : data.component }}
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'text-connector-row-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>: {{
                  item['value_start_' + functionService.languageTempCode] | vhLanguage : 'Văn bản bắt đầu'
                  }} ---------- {{
                  item['value_end_' + functionService.languageTempCode] | vhLanguage : 'Văn bản kết thúc'
                  }}
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'button-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>
                  : {{ item['value_' + functionService.languageTempCode] | vhLanguage : 'button' : data.component }}
                  <ng-container *ngIf="
                    (item['value_' + functionService.languageTempCode] != undefined) && 
                    !item['value_' + functionService.languageTempCode]?.trim()
                  ">
                    <strong class="item-name ml-4">{{ 'nhan' | translate }}</strong>
                    : {{ item['accessibility_aria_label_' + functionService.languageTempCode] || 'Nút điều hướng' }}
                  </ng-container>
                  <ng-container *ngIf="item.icon_enable">
                    <strong class="item-name ml-4">{{ 'bieu_tuong' | translate }}</strong>
                    : <mat-icon *ngIf="item.icon_name">{{ item.icon_name }}</mat-icon>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'popup-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>
                  : {{ item['value_' + functionService.languageTempCode] | vhLanguage : 'popup' : data.component }}
                  <ng-container *ngIf="
                    (item['value_' + functionService.languageTempCode] != undefined) && 
                    !item['value_' + functionService.languageTempCode]?.trim()
                  ">
                    <strong class="item-name ml-4">{{ 'nhan' | translate }}</strong>
                    : {{ item['accessibility_aria_label_' + functionService.languageTempCode] || 'Nút gọi hộp thoại' }}
                  </ng-container>
                  <ng-container *ngIf="item.icon_enable">
                    <strong class="item-name ml-4">{{ 'bieu_tuong' | translate }}</strong>
                    : <mat-icon *ngIf="item.icon_name">{{ item.icon_name }}</mat-icon>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'date-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>: {{ item.value | date: 'dd-MM-yyyy HH:mm:ss ' }}
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'video-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>:
                  <iframe *ngIf="!item.value.includes('tiktok.com')"
                    width="150px" height="100px"
                    [src]="sanitizer.bypassSecurityTrustResourceUrl(item.value)"
                    alt="video-repeat" class="mb-2">
                  </iframe>
                  <div *ngIf="item.value.includes('tiktok.com')"
                    [style.width]="'100px'" [style.height]="'150px'"
                    [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.value)">
                  </div>
                  <!-- Mô tả nội dung của video -->
                  <strong class="item-name ml-4">{{ 'tieu_de' | translate }}</strong>
                  : {{ item['accessibility_title_' + functionService.languageTempCode] || 'Video youtube' }}
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'map-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>:
                  <iframe width="200px" height="100px" scrolling="no" loading="lazy"
                    [src]="sanitizer.bypassSecurityTrustResourceUrl(item.value)"
                    referrerpolicy="no-referrer-when-downgrade" alt="map-repeat" class="mb-2"
                    style="pointer-events: none;" allow="geolocation 'none'">
                  </iframe>
                  <!-- Mô tả nội dung của bản đồ -->
                  <strong class="item-name ml-4">{{ 'tieu_de' | translate }}</strong>
                  : {{ item['accessibility_title_' + functionService.languageTempCode] || 'Bản đồ' }}
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'image-detail-repeat'">
                <div class="editable-cell" (click)="chooseItemEdit(item, dataRow)">
                  <strong class="item-name">{{ findObjectName(item) }}</strong>:
                  <div class="mb-2 d-flex overflow-auto" style="gap: 8px; flex: 1;">
                    <img *ngFor="let itemImg of (item[deviceTemp + '_value'] ?? sampleImgDetail)" width="100px"
                      height="100px" [src]="itemImg" alt="image-detail-repeat" class="item-img" />
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </td>
          <td>
            <a nz-popconfirm [nzPopconfirmTitle]="'ban_co_chac_chan_muon_xoa' | translate"
              (nzOnConfirm)="deleteRow(dataRow._id)"><span nz-icon nzType="delete" class="btn-delete"
                nzTheme="outline"></span></a>
          </td>
        </tr>

        <!-- MODAL EDIT -->
        <nz-modal [(nzVisible)]="isOpenModal" (nzOnCancel)="isOpenModal = false" [nzFooter]="null" [nzStyle]="{ 
          top: '32px', width: (itemEdit?.type == 'image-repeat' && isFullscreenImage?.[deviceTemp]) ? '1000px' : '500px' 
        }">
          <ng-container *nzModalContent>
            <div *ngIf="itemEdit.type == 'image-repeat'" class="d-flex" style="gap: 16px">
              <div style="width: 490px;">
                <div class="d-flex justify-content-between align-items-center mt-4 mb-2" style="gap: 8px;">
                  <span>{{'chon_thiet_bi' | translate}}: </span>
                  <nz-select style="flex: 1;" [ngModel]="deviceTemp" (ngModelChange)="deviceTemp = $event"
                    nzPlaceHolder="{{'chon_thiet_bi' | translate}}" nzAllowClear>
                    <ng-container *ngFor="let d of functionService.devices">
                      <nz-option
                        *ngIf="subproject?.[d.value + '_template_display'] && (d.value !== 'desktop' || subproject?.style == 'website')"
                        [nzValue]="d.value" nzLabel="{{d.label | translate}}"></nz-option>
                    </ng-container>
                  </nz-select>
                </div>
                <div class="image-container">
                  <img nz-image width="100px" height="100px" alt="Lỗi hình ảnh" class="mb-2 mr-2"
                    [nzSrc]="itemEdit[deviceTemp + '_value'] || itemEdit.value" nz-tooltip nzTooltipPlacement="left"
                    [nzTooltipTitle]="itemEdit[deviceTemp + '_value']?.includes(id_subproject) ? tooltipImgInfo : null" />
                  <div class="image-right">
                    <div style="margin-bottom: 10px; display:flex; align-items: center; gap: 1rem;">
                      <button class="_icon_connect  _icon_connect_active">
                        <!-- icon upload từ thiết bị -->
                        <label for="upload" nz-icon nzType="upload" nzTheme="outline" *ngIf="source == 'device'"
                          (click)="startEdit(itemEdit)"></label>
                        <input type="file" id="upload" hidden (change)="onUpload($event, dataRow)">
                        <!-- icon upload từ thư viện -->
                        <span nz-icon nzType="picture" nzTheme="outline" *ngIf="source == 'library'"
                          (click)="startEdit(itemEdit); openLibrary(dataRow, 'img')"></span>
                        <!-- icon ảnh miễn phí -->
                        <span nz-icon nzType="cloud-upload" nzTheme="outline" *ngIf="source == 'free_img'"
                          (click)="startEdit(itemEdit); openFreeImage(dataRow)"></span>
                        <!-- icon đường dẫn ảnh -->
                        <span nz-popover nzPopoverTitle="{{'duong_dan_anh' | translate}}" nzPopoverTrigger="click"
                          [nzPopoverContent]="contentTemplate" nz-icon nzType="disconnect" nzTheme="outline"
                          *ngIf="source == 'url'">
                        </span>
                        <ng-template #contentTemplate>
                          <input style="width: 260px;" class="input mr-1" type="text" [(ngModel)]="itemEdit.value"
                            [value]="itemEdit.value" placeholder="{{'nhap_duong_dan_lien_ket' | translate}}">
                          <span role="button" class="text-success" (click)="handleLinkImg(dataRow)">{{'ap_dung' |
                            translate}}</span>
                        </ng-template>
                      </button>

                      <button nz-button nzType="primary" (click)="openUploadToServer()"
                        *ngIf="!(itemEdit[deviceTemp + '_value'] || itemEdit.value)?.includes(id_subproject)">
                        {{'chuyen_anh_len_server' | translate}}
                      </button>
                    </div>
                    <div class="d-flex justify-content-between align-items-center my-1">
                      <span>{{ 'anh_dung_chung_cho_cac_thiet_bi' | translate }}</span>
                      <nz-switch [(ngModel)]="isSharedImg"></nz-switch>
                    </div>
                    <div style="margin-bottom: 10px;">
                      <nz-select [(ngModel)]="source">
                        <nz-option *ngFor="let source of sources" [nzValue]="source.value"
                          [nzLabel]="source.label | translate"></nz-option>
                      </nz-select>
                    </div>

                    <div *ngIf="source == 'device'">
                      <p class="m-0">{{'nen_anh_tai_len' | translate}}</p>
                      <nz-select style="margin-bottom: 15px" [(ngModel)]="compressType"
                        nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
                        <nz-option [nzValue]="'no-compress'"
                          nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
                        <nz-option [nzValue]="'compress-frame'"
                          nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
                        <nz-option [nzValue]="'custom'"
                          nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
                      </nz-select>

                      <div style="display:flex; align-items:center; gap: 8px">
                        <mat-form-field *ngIf="compressType == 'custom'">
                          <mat-label>{{'chieu_rong' | translate}}</mat-label>
                          <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
                        </mat-form-field>

                        <mat-form-field *ngIf="compressType == 'custom'">
                          <mat-label>{{'chieu_cao' | translate}}</mat-label>
                          <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
                        </mat-form-field>
                      </div>
                    </div>

                    <button *ngIf="isDesignImageSizeValid" nz-tooltip class="w-100" nz-button nzType="primary"
                      [nzTooltipTitle]="'chi_dung_cap_nhat_kich_thuoc_anh_cho_nhung_hinh_anh_dung_yen_khong_co_hieu_ung_truot' | translate"
                      (click)="updateDesignImageSize(itemEdit, dataRow)">
                      {{'cap_nhat_kich_thuoc_anh_theo_kich_thuoc_thiet_ke' | translate}}
                    </button>
                  </div>
                </div>

                <!-- Cập nhật mô tả nội dung ảnh -->
                <div class="mt-2 mb-1">
                  <hr class="mb-2" />
                  <app-select-language-config [displayLabel]="true" [isAdmin]="true"></app-select-language-config>
                </div>
                <div *ngIf="isEffectOverlayImage?.[deviceTemp]" class="config-font" style="margin-bottom: 20px;">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">{{'noi_dung_hieu_ung' | translate}}</p>
                    <!-- Nút dịch -->
                    <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                      dataKey: 'value', itemEdit, dataRow
                    }"></ng-container>
                  </div>
                  <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                    [ngModel]="itemEdit['value_' + functionService.languageTempCode] || 'Ảnh'"
                    (ngModelChange)="itemEdit['value_' + functionService.languageTempCode] = $event"
                    (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }">
                  </textarea>
                </div>
                <div class="config-font" style="margin-bottom: 20px;">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">{{'cap_nhat_mo_ta_noi_dung' | translate}}</p>
                    <!-- Nút dịch -->
                    <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                      dataKey: 'accessibility_alt', itemEdit, dataRow
                    }"></ng-container>
                  </div>
                  <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                    [ngModel]="itemEdit['accessibility_alt_' + functionService.languageTempCode] || 'Ảnh'"
                    (ngModelChange)="itemEdit['accessibility_alt_' + functionService.languageTempCode] = $event"
                    (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }" nz-tooltip
                    [nzTooltipTitle]="'*_giai_thich_aria_label' | translate" nzOverlayClassName="aria-label-tooltip">
                  </textarea>
                </div>

                <!-- Cập nhật liên kết -->
                <div class="config-font">
                  <!-- type-link -->
                  <div class="type-link">
                    <p class="type-link__title">{{'cap_nhat_duong_dan_lien_ket' | translate}}</p>
                    <nz-select class="type-link__select" [(ngModel)]="itemEdit.type_link"
                      (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                      nzPlaceHolder="{{'chon_kieu_lien_ket' | translate}}" allowClear>
                      <nz-option *ngFor="let item of type_link" [nzValue]="item.value"
                        nzLabel="{{item.label | translate}}"></nz-option>
                    </nz-select>
                  </div>

                  <!-- ĐẾN TRANG -->
                  <div class="connect-page" *ngIf="itemEdit.type_link == 'page_link'">
                    <nz-select [(ngModel)]="itemEdit.link" (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                      nzPlaceHolder="{{'chon_trang_lien_ket' | translate}}" allowClear nzShowSearch>
                      <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link"
                        [nzLabel]="page['name_' + functionService.languageTempCode] || page.name">
                      </nz-option>
                    </nz-select>
                  </div>

                  <!-- LIÊN KẾT ĐIỀU HƯỚNG -->
                  <div class="navigation-link" *ngIf="itemEdit.type_link == 'navigation_link'">
                    <nz-input-group [nzSuffix]="suffixIconClose">
                      <input type="text" nz-input placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                        [(ngModel)]="itemEdit.link" (blur)="getBlocksbyPage();updateData(dataRow)" />
                    </nz-input-group>
                    <ng-template #suffixIconClose>
                      <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('link')"></span>
                    </ng-template>
                  </div>

                  <!-- ĐẾN MAIL -->
                  <div class="mail-link" *ngIf="itemEdit.type_link == 'mailto'">
                    <nz-input-group [nzSuffix]="suffixIconClose"
                      [style.border-color]="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto }) ? 'red' : '#d9d9d9'">
                      <input type="text" nz-input placeholder="viethas.info@gmail.com" [(ngModel)]="itemEdit.mailto"
                        (blur)="updateData(dataRow)" />
                    </nz-input-group>
                    <ng-template #suffixIconClose>
                      <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('mailto')"></span>
                    </ng-template>
                    <p *ngIf="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto })"
                      class="text-danger mt-1 pl-2 lh-base">
                      {{'email_khong_hop_le' | translate}}
                    </p>
                  </div>

                  <!-- ĐẾN SỐ ĐIỆN THOẠI -->
                  <div class="mail-link" *ngIf="itemEdit.type_link == 'tel'">
                    <nz-input-group [nzSuffix]="suffixIconClose"
                      [style.border-color]="'#d9d9d9'">
                      <input type="text" nz-input placeholder="0909925354" [(ngModel)]="itemEdit.tel"
                        (blur)="updateData(dataRow)" />
                    </nz-input-group>
                    <ng-template #suffixIconClose>
                      <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('tel')"></span>
                    </ng-template>
                  </div>

                  <!-- Hành động khi nhấn -->
                  <div *ngIf="itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link'"
                    class="mt-3">
                    <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
                    <br />
                    <nz-select id="scroll-select" [(ngModel)]="itemEdit.is_scroll"
                      (ngModelChange)="updateData(dataRow)">
                      <nz-option *ngFor="let item of clickActionOptions" [nzValue]="item.value"
                        [nzLabel]="item.label | translate"></nz-option>
                    </nz-select>
                  </div>

                  <!-- CUỘN ĐẾN BLOCK -->
                  <ng-container style="width: 100%"
                    *ngIf="(itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link') && itemEdit.is_scroll == 'scroll_to_block'">
                    <nz-select style="margin: 8px 0" [nzPlaceHolder]="'chon_khoi' | translate"
                      [(ngModel)]="itemEdit.scroll_block_id" (ngModelChange)="updateData(dataRow)">
                      <nz-option *ngFor="let block of blocks_of_page" [nzValue]="block._id"
                        [nzLabel]="block.name | translate"></nz-option>
                    </nz-select>

                    <div class="form-group">
                      <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
                      <input type="number" nz-input class="field-fill" [(ngModel)]="itemEdit.scroll_distance"
                        (input)="updateData(dataRow)" />
                    </div>
                  </ng-container>


                  <!-- LIÊN KẾT TRANG KHÁC (URL) -->
                  <div class="connect-link" *ngIf="itemEdit.type_link == 'hyper_link'">
                    <nz-input-group [nzSuffix]="suffixIconClose">
                      <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="itemEdit.hyper_link"
                        (blur)="updateData(dataRow)" />
                    </nz-input-group>
                    <ng-template #suffixIconClose>
                      <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('hyper_link')"></span>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div *ngIf="isFullscreenImage?.[deviceTemp]" class="p-2" style="width: 490px;">
                <h3 class="mt-3 mb-0">{{'anh_toan_man_hinh' | translate}}</h3>
                <div>
                  <div class="d-flex overflow-auto" style="gap: 4px;" cdkDropList cdkDropListOrientation="horizontal"
                    (cdkDropListDropped)="dropImgFullscreens($event, dataRow)">
                    <div *ngFor="let imgFullScreen of itemEdit[deviceTemp + '_value_fullscreens']; let iFull = index"
                      cdkDrag class="d-flex flex-column" style="width: 100px; gap: 2px;">
                      <img nz-image width="100px" height="100px" alt="Lỗi hình ảnh"
                        [nzSrc]="imgFullScreen || itemEdit.value" nz-tooltip nzTooltipPlacement="top"
                        [nzTooltipTitle]="imgFullScreen?.includes(id_subproject) ? tooltipImgInfo : null" />

                      <button nz-button nzType="default" (click)="handleDelImgFullscreens(dataRow, iFull)">
                        {{'xoa_anh' | translate}}
                      </button>
                      <button nz-button nzType="primary" (click)="okUploadToServer(itemEdit, 'fullscreen', iFull)"
                        style="white-space: pre-line;" *ngIf="!imgFullScreen?.includes(id_subproject)">
                        {{'day_len_server' | translate}}
                      </button>
                    </div>
                  </div>
                  <div style="margin-bottom: 10px; display:flex; align-items: center; gap: 1rem;">
                    <label *ngIf="source == 'device'" class="_icon_connect  _icon_connect_active w-100 mt-2"
                      style="border-radius: 0; cursor: pointer;" (click)="startEdit(itemEdit)" for="uploadFullscreen">
                      <!-- icon upload từ thiết bị -->
                      <span nz-icon nzType="upload" nzTheme="outline"></span>
                      <span>{{'them_anh' | translate}}</span>
                    </label>
                    <input type="file" id="uploadFullscreen" hidden (change)="onUpload($event, dataRow, 'fullscreen')">
                    <button class="_icon_connect  _icon_connect_active w-100 mt-2" style="border-radius: 0;"
                      *ngIf="source == 'library'" (click)="startEdit(itemEdit); openLibrary(dataRow, 'fullscreen')">
                      <!-- icon upload từ thư viện -->
                      <span nz-icon nzType="picture" nzTheme="outline"></span>
                      <span>{{'them_anh' | translate}}</span>
                    </button>
                    <button class="_icon_connect  _icon_connect_active w-100 mt-2" style="border-radius: 0;"
                      *ngIf="source == 'free_img'" (click)="startEdit(itemEdit); openFreeImage(dataRow, 'fullscreen')">
                      <!-- icon ảnh miễn phí -->
                      <span nz-icon nzType="cloud-upload" nzTheme="outline"></span>
                      <span>{{'them_anh' | translate}}</span>
                    </button>
                    <button class="_icon_connect  _icon_connect_active w-100 mt-2" style="border-radius: 0;"
                      *ngIf="source == 'url'" nz-popover nzPopoverTitle="{{'duong_dan_anh' | translate}}"
                      nzPopoverTrigger="click" [nzPopoverContent]="contentTemplate">
                      <!-- icon đường dẫn ảnh -->
                      <span nz-icon nzType="disconnect" nzTheme="outline"></span>
                      <span>{{'them_anh' | translate}}</span>
                    </button>
                    <ng-template #contentTemplate>
                      <input style="width: 260px;" class="input mr-1" type="text" [ngModel]="itemEdit.value_fullscreen"
                        [value]="itemEdit.value_fullscreen" placeholder="{{'nhap_duong_dan_lien_ket' | translate}}"
                        (ngModelChange)="itemEdit.value_fullscreen = $event">
                      <span role="button" class="text-success" (click)="handleLinkImg(dataRow, 'fullscreen')">
                        {{'ap_dung' | translate}}
                      </span>
                    </ng-template>
                  </div>
                  <div class="d-flex justify-content-between align-items-center my-1">
                    <span>{{ 'anh_dung_chung_cho_cac_thiet_bi' | translate }}</span>
                    <nz-switch [(ngModel)]="isSharedImg"></nz-switch>
                  </div>
                  <div style="margin-bottom: 10px;">
                    <nz-select [(ngModel)]="source">
                      <nz-option *ngFor="let source of sources" [nzValue]="source.value"
                        [nzLabel]="source.label | translate"></nz-option>
                    </nz-select>
                  </div>

                  <div *ngIf="source == 'device'">
                    <p class="m-0">{{'nen_anh_tai_len' | translate}}</p>
                    <nz-select style="margin-bottom: 15px" [(ngModel)]="compressType"
                      nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
                      <nz-option [nzValue]="'no-compress'"
                        nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
                      <nz-option [nzValue]="'compress-frame'"
                        nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
                      <nz-option [nzValue]="'custom'"
                        nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
                    </nz-select>

                    <div style="display:flex; align-items:center; gap: 8px">
                      <mat-form-field *ngIf="compressType == 'custom'">
                        <mat-label>{{'chieu_rong' | translate}}</mat-label>
                        <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
                      </mat-form-field>

                      <mat-form-field *ngIf="compressType == 'custom'">
                        <mat-label>{{'chieu_cao' | translate}}</mat-label>
                        <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container
              *ngIf="itemEdit.type == 'text-repeat' || itemEdit.type == 'button-repeat' || itemEdit.type == 'popup-repeat'">
              <!-- Chọn ngôn ngữ -->
              <div class="mb-3">
                <app-select-language-config [displayLabel]="true" [isAdmin]="true"></app-select-language-config>
              </div>
              <!-- Cập nhật chữ -->
              <div class="config-font" style="margin-bottom: 20px;">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">{{'cap_nhat_noi_dung_hien_thi' | translate}}</p>
                  <!-- Nút dịch -->
                  <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                    dataKey: 'value', itemEdit, dataRow
                  }"></ng-container>
                </div>
                <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                  [ngModel]="itemEdit['value_' + functionService.languageTempCode] | vhLanguage : mapType[itemEdit.type] : data.component"
                  (ngModelChange)="itemEdit['value_' + functionService.languageTempCode] = $event"
                  (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }"></textarea>
              </div>
              <ng-container *ngIf="itemEdit.type == 'button-repeat' || itemEdit.type == 'popup-repeat'">
                <!-- Cập nhật nhãn -->
                <div class="config-font" style="margin-bottom: 20px;" *ngIf="
                  (itemEdit['value_' + functionService.languageTempCode] != undefined) && 
                  !itemEdit['value_' + functionService.languageTempCode]?.trim()
                ">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">{{'cap_nhat_nhan' | translate}}</p>
                    <!-- Nút dịch -->
                    <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                      dataKey: 'accessibility_aria_label', itemEdit, dataRow
                    }"></ng-container>
                  </div>
                  <textarea nz-input class="content" placeholder="{{'nhan' | translate}}..."
                    [ngModel]="itemEdit['accessibility_aria_label_' + functionService.languageTempCode] || 'Nút điều hướng'"
                    (ngModelChange)="itemEdit['accessibility_aria_label_' + functionService.languageTempCode] = $event"
                    (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }" nz-tooltip
                    [nzTooltipTitle]="'*_giai_thich_aria_label' | translate" nzOverlayClassName="aria-label-tooltip">
                  </textarea>
                </div>
                <!-- Biểu tượng -->
                <div class="d-flex justify-content-between mt-1 mb-3 align-items-center">
                  <p class="title" style="line-height: 1.5; margin: 0">{{'su_dung_bieu_tuong' | translate}}</p>
                  <nz-switch [(ngModel)]="itemEdit.icon_enable" (ngModelChange)="updateData(dataRow)"></nz-switch>
                  <div class="d-flex justify-content-between">
                    <mat-icon>{{ itemEdit.icon_name }}</mat-icon>
                    <button nz-button nzType="default" (click)="openDialogChooseIcon()"
                      style="border-radius: 6px; border: 2px solid #333" [disabled]="!itemEdit.icon_enable">
                      {{'thay_doi' | translate}}
                    </button>
                  </div>
                </div>
              </ng-container>
              <!-- Cập nhật liên kết -->
              <div class="config-font">
                <!-- type-link -->
                <div class="type-link">
                  <p class="type-link__title">{{'cap_nhat_duong_dan_lien_ket' | translate}}</p>
                  <nz-select class="type-link__select" [(ngModel)]="itemEdit.type_link"
                    (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                    nzPlaceHolder="{{'chon_kieu_lien_ket' | translate}}" allowClear>
                    <nz-option *ngFor="let item of type_link" [nzValue]="item.value"
                      nzLabel="{{item.label | translate}}"></nz-option>
                  </nz-select>
                </div>

                <!-- ĐẾN TRANG -->
                <div class="connect-page" *ngIf="itemEdit.type_link == 'page_link'">
                  <nz-select [(ngModel)]="itemEdit.link" (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                    nzPlaceHolder="{{'chon_trang_lien_ket' | translate}}" allowClear nzShowSearch>
                    <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link || ''"
                      [nzLabel]="page['name_' + functionService.languageTempCode] || page.name">
                    </nz-option>
                  </nz-select>
                </div>

                <!-- LIÊN KẾT ĐIỀU HƯỚNG -->
                <div class="navigation-link" *ngIf="itemEdit.type_link == 'navigation_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                      [(ngModel)]="itemEdit.link" (blur)="getBlocksbyPage();updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('link')"></span>
                  </ng-template>
                </div>

                <!-- ĐẾN MAIL -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'mailto'">
                  <nz-input-group [nzSuffix]="suffixIconClose"
                    [style.border-color]="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto }) ? 'red' : '#d9d9d9'">
                    <input type="text" nz-input placeholder="viethas.info@gmail.com" [(ngModel)]="itemEdit.mailto"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('mailto')"></span>
                  </ng-template>
                  <p *ngIf="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto })"
                    class="text-danger mt-1 pl-2 lh-base">
                    {{'email_khong_hop_le' | translate}}
                  </p>
                </div>

                <!-- ĐẾN SỐ ĐIỆN THOẠI -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'tel'">
                  <nz-input-group [nzSuffix]="suffixIconClose" [style.border-color]="'#d9d9d9'">
                    <input type="text" nz-input placeholder="0909925354" [(ngModel)]="itemEdit.tel"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('tel')"></span>
                  </ng-template>
                </div>

                <!-- Hành động khi nhấn -->
                <div *ngIf="itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link'" class="mt-3">
                  <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
                  <br />
                  <nz-select id="scroll-select" [(ngModel)]="itemEdit.is_scroll" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let item of clickActionOptions" [nzValue]="item.value"
                      [nzLabel]="item.label | translate"></nz-option>
                  </nz-select>
                </div>

                <!-- CUỘN ĐẾN BLOCK -->
                <ng-container style="width: 100%"
                  *ngIf="(itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link') && itemEdit.is_scroll == 'scroll_to_block'">
                  <nz-select style="margin: 8px 0" [nzPlaceHolder]="'chon_khoi' | translate"
                    [(ngModel)]="itemEdit.scroll_block_id" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let block of blocks_of_page" [nzValue]="block._id"
                      [nzLabel]="block.name | translate"></nz-option>
                  </nz-select>

                  <div class="form-group">
                    <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
                    <input type="number" nz-input class="field-fill" [(ngModel)]="itemEdit.scroll_distance"
                      (input)="updateData(dataRow)" />
                  </div>
                </ng-container>

                <!-- LIÊN KẾT TRANG KHÁC (URL) -->
                <div class="connect-link" *ngIf="itemEdit.type_link == 'hyper_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="itemEdit.hyper_link"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('hyper_link')"></span>
                  </ng-template>
                </div>
              </div>

              <!-- Gọi hộp thoại -->
              <ng-container *ngIf="itemEdit.type == 'popup-repeat'">
                <!-- type-link -->
                <div class="type-link">
                  <p class="type-link__title">{{'goi_hop_thoai' | translate}}</p>
                  <nz-select class="type-link__select" [(ngModel)]="itemEdit.id_freeblock"
                    (ngModelChange)="updateData(dataRow)" nzPlaceHolder="{{'goi_hop_thoai' | translate}}" nzAllowClear>
                    <nz-option *ngFor="let block of popupHovers" [nzValue]="block._id"
                      nzLabel="{{block.name | translate}}"></nz-option>
                  </nz-select>
                </div>
              </ng-container>

            </ng-container>

            <ng-container *ngIf="itemEdit.type == 'date-repeat'">
              <!-- Chọn ngày và giờ -->
              <nz-date-picker nzShowTime nzFormat="dd-MM-yyyy HH:mm:ss" [(ngModel)]="itemEdit.value"
                (ngModelChange)="onDateTimeChange($event, itemEdit)"
                (nzOnOk)="onDateTimeOk($event, dataRow)"></nz-date-picker>
              <!-- Cập nhật liên kết -->
              <div class="config-font">
                <!-- type-link -->
                <div class="type-link">
                  <p class="type-link__title">{{'cap_nhat_duong_dan_lien_ket' | translate}}</p>
                  <nz-select class="type-link__select" [(ngModel)]="itemEdit.type_link"
                    (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                    nzPlaceHolder="{{'chon_kieu_lien_ket' | translate}}" allowClear>
                    <nz-option *ngFor="let item of type_link" [nzValue]="item.value"
                      nzLabel="{{item.label | translate}}"></nz-option>
                  </nz-select>
                </div>

                <!-- ĐẾN TRANG -->
                <div class="connect-page" *ngIf="itemEdit.type_link == 'page_link'">
                  <nz-select [(ngModel)]="itemEdit.link" (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                    nzPlaceHolder="{{'chon_trang_lien_ket' | translate}}" allowClear nzShowSearch>
                    <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link || ''"
                      [nzLabel]="page['name_' + functionService.languageTempCode] || page.name">
                    </nz-option>
                  </nz-select>
                </div>

                <!-- LIÊN KẾT ĐIỀU HƯỚNG -->
                <div class="navigation-link" *ngIf="itemEdit.type_link == 'navigation_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                      [(ngModel)]="itemEdit.link" (blur)="getBlocksbyPage();updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('link')"></span>
                  </ng-template>
                </div>

                <!-- ĐẾN MAIL -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'mailto'">
                  <nz-input-group [nzSuffix]="suffixIconClose"
                    [style.border-color]="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto }) ? 'red' : '#d9d9d9'">
                    <input type="text" nz-input placeholder="viethas.info@gmail.com" [(ngModel)]="itemEdit.mailto"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('mailto')"></span>
                  </ng-template>
                  <p *ngIf="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto })"
                    class="text-danger mt-1 pl-2 lh-base">
                    {{'email_khong_hop_le' | translate}}
                  </p>
                </div>

                <!-- ĐẾN SỐ ĐIỆN THOẠI -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'tel'">
                  <nz-input-group [nzSuffix]="suffixIconClose" [style.border-color]="'#d9d9d9'">
                    <input type="text" nz-input placeholder="0909925354" [(ngModel)]="itemEdit.tel"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('tel')"></span>
                  </ng-template>
                </div>

                <!-- Hành động khi nhấn -->
                <div *ngIf="itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link'" class="mt-3">
                  <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
                  <br />
                  <nz-select id="scroll-select" [(ngModel)]="itemEdit.is_scroll" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let item of clickActionOptions" [nzValue]="item.value"
                      [nzLabel]="item.label | translate"></nz-option>
                  </nz-select>
                </div>

                <!-- CUỘN ĐẾN BLOCK -->
                <ng-container style="width: 100%"
                  *ngIf="(itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link') && itemEdit.is_scroll == 'scroll_to_block'">
                  <nz-select style="margin: 8px 0" [nzPlaceHolder]="'chon_khoi' | translate"
                    [(ngModel)]="itemEdit.scroll_block_id" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let block of blocks_of_page" [nzValue]="block._id"
                      [nzLabel]="block.name | translate"></nz-option>
                  </nz-select>

                  <div class="form-group">
                    <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
                    <input type="number" nz-input class="field-fill" [(ngModel)]="itemEdit.scroll_distance"
                      (input)="updateData(dataRow)" />
                  </div>
                </ng-container>

                <!-- LIÊN KẾT TRANG KHÁC (URL) -->
                <div class="connect-link" *ngIf="itemEdit.type_link == 'hyper_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="itemEdit.hyper_link"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('hyper_link')"></span>
                  </ng-template>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="itemEdit.type == 'video-repeat'">
              <!-- text-area url -->
              <div class="config-font" style="margin-bottom: 20px;">
                <p class="title">{{'cap_nhat_noi_dung_hien_thi' | translate}}</p>
                <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                  [(ngModel)]="itemEdit['iframe']" (blur)="updateVideoRepeat('is_mute', $event);updateData(dataRow)"
                  [nzAutosize]="{ minRows: 3, maxRows: 15 }">
                </textarea>

                <button nzType="primary" nz-button (click)="isOpenGuideVideo = true"
                  class="_btn _btn_add d-flex align-items-center right-all-content mr-2 my-2">
                  {{'huong_dan_khach_hang_lay_link_video' | translate}}
                </button>

                <!-- Loại youtube -->
                <ng-container
                  *ngIf="itemEdit?.['iframe']?.includes('youtube.com') || itemEdit?.['iframe']?.includes('youtube-nocookie.com')">
                  <p
                    style="line-height: 1.4; font-size: 13px; color: #333; font-style: italic; text-align: justify; margin: 12px 0;">
                    {{'de_hien_thi_cau_hinh_tu_dong_phat_thi_can_tat_am_thanh_vi_hau_het_trinh_duyet_se_chan_tu_dong_phat_neu_video_youtube_co_am_thanh'
                    | translate}}
                  </p>

                  <!-- ÂM THANH -->
                  <div class="border-type mt-4">
                    <h4>{{'am_thanh' | translate}}</h4>
                    <nz-switch [(ngModel)]="itemEdit.is_mute"
                      (ngModelChange)="updateVideoRepeat('is_mute', $event);updateData(dataRow)"></nz-switch>
                  </div>

                  <!-- TỰ ĐỘNG LẶP -->
                  <div class="border-type">
                    <h4>{{'tu_dong_lap' | translate}}</h4>
                    <nz-switch [(ngModel)]="itemEdit.loop"
                      (ngModelChange)="updateVideoRepeat('loop', $event);updateData(dataRow)"></nz-switch>
                  </div>

                  <!-- THÀNH CÔNG CỤ -->
                  <div class="border-type">
                    <h4>{{'thanh_cong_cu' | translate}}</h4>
                    <nz-switch [(ngModel)]="itemEdit.controls"
                      (ngModelChange)="updateVideoRepeat('controls', $event);updateData(dataRow)"></nz-switch>
                  </div>

                  <!-- TỰ ĐỘNG PHÁT -->
                  <!-- autoplay phải đi với mute, nên nếu không mute thì autoplay sẽ tự động set false (Xem tại https://developer.chrome.com/blog/autoplay/) -->
                  <div *ngIf="!itemEdit.is_mute" class="border-type">
                    <h4>{{'tu_dong_phat' | translate}}</h4>
                    <nz-switch [(ngModel)]="itemEdit.autoplay"
                      (ngModelChange)="updateVideoRepeat('autoplay', $event);updateData(dataRow)"></nz-switch>
                  </div>
                </ng-container>

                <!-- CẬP NHẬT MÔ TẢ NỘI DUNG CỦA VIDEO -->
                <div class="mt-2 mb-1">
                  <app-select-language-config [displayLabel]="true" [isAdmin]="true"></app-select-language-config>
                </div>
                <div class="config-font" style="margin-bottom: 20px;">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">{{'cap_nhat_tieu_de_video' | translate}}</p>
                    <!-- Nút dịch -->
                    <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                      dataKey: 'accessibility_title', itemEdit, dataRow
                    }"></ng-container>
                  </div>
                  <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                    [ngModel]="itemEdit['accessibility_title_' + functionService.languageTempCode] || 'Video youtube'"
                    (ngModelChange)="itemEdit['accessibility_title_' + functionService.languageTempCode] = $event"
                    (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }" nz-tooltip
                    [nzTooltipTitle]="'*_giai_thich_aria_label' | translate" nzOverlayClassName="aria-label-tooltip">
                  </textarea>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="itemEdit.type == 'map-repeat'">
              <nz-radio-group [(ngModel)]="radioValue">
                <label nz-radio nzValue="location">{{ 'nhap_dia_chi' | translate }}</label>
                <label nz-radio nzValue="iframe">{{ 'dung_the_nhung' | translate }}</label>
              </nz-radio-group>
              <!-- Thêm địa chỉ bằng cách nhập -->
              <div class="container-font" *ngIf="radioValue == 'location'">
                <div class="config-text" style="width:100%">
                  <mat-form-field style="width:100%">
                    <mat-label>{{ 'nhap_dia_chi' | translate }} </mat-label>
                    <textarea matInput [(ngModel)]="itemEdit.local"
                      (blur)="getLocal_atwMapRepeat(itemEdit, dataRow)"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <!-- Thêm địa chỉ bằng iframe -->
              <div *ngIf="radioValue == 'iframe'" class="map__item--change-link">
                <div>
                  <input #myInput nz-input
                    placeholder="<iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.3565404084443!2d106' width='600' height='450' style='border:0;' allowfullscreen='' loading='lazy' referrerpolicy='no-referrer-when-downgrade'></iframe>"
                    class="input_iframe form-group" nzSize="large" [(ngModel)]="itemEdit.iframe" />
                </div>
                <div class="map__item--change-link--button d-flex flex-column">
                  <button nz-button nzType="primary" (click)="getLink_atwMapRepeat(itemEdit, dataRow)">{{'cap_nhat' |
                    translate}}</button>
                </div>
              </div>

              <button nzType="primary" nz-button (click)="isOpenGuideMap = true"
                class="_btn _btn_add d-flex align-items-center right-all-content mr-2 my-2">
                {{ 'huong_dan_khach_hang_chen_ban_do' | translate }}
              </button>

              <!-- CẬP NHẬT MÔ TẢ NỘI DUNG CỦA BẢN ĐỒ -->
              <div class="mt-2 mb-1">
                <app-select-language-config [displayLabel]="true" [isAdmin]="true"></app-select-language-config>
              </div>
              <div class="config-font" style="margin-bottom: 20px;">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">{{'cap_nhat_mo_ta_noi_dung' | translate}}</p>
                  <!-- Nút dịch -->
                  <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                    dataKey: 'accessibility_title', itemEdit, dataRow
                  }"></ng-container>
                </div>
                <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                  [ngModel]="itemEdit['accessibility_title_' + functionService.languageTempCode] || 'Bản đồ'"
                  (ngModelChange)="itemEdit['accessibility_title_' + functionService.languageTempCode] = $event"
                  (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }" nz-tooltip
                  [nzTooltipTitle]="'*_giai_thich_aria_label' | translate" nzOverlayClassName="aria-label-tooltip">
                </textarea>
              </div>
            </ng-container>

            <ng-container *ngIf="itemEdit.type == 'text-connector-row-repeat'">
              <!-- Chọn ngôn ngữ -->
              <div class="mb-3">
                <app-select-language-config [displayLabel]="true" [isAdmin]="true"></app-select-language-config>
              </div>
              <!-- Cập nhật chữ -->
              <div class="config-font" style="margin-bottom: 20px;">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">{{'cap_nhat_van_ban_bat_dau' | translate}}</p>
                  <!-- Nút dịch -->
                  <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                    dataKey: 'value_start', itemEdit, dataRow
                  }"></ng-container>
                </div>
                <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                  [ngModel]="itemEdit['value_start_' + functionService.languageTempCode] | vhLanguage : 'Văn bản bắt đầu'"
                  (ngModelChange)="itemEdit['value_start_' + functionService.languageTempCode] = $event"
                  (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }"></textarea>
              </div>
              <!-- Cập nhật chữ -->
              <div class="config-font" style="margin-bottom: 20px;">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">{{'cap_nhat_van_ban_ket_thuc' | translate}}</p>
                  <!-- Nút dịch -->
                  <ng-container *ngTemplateOutlet="btnTranslateTemp; context: {
                    dataKey: 'value_end', itemEdit, dataRow
                  }"></ng-container>
                </div>
                <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                  [ngModel]="itemEdit['value_end_' + functionService.languageTempCode] | vhLanguage : 'Văn bản kết thúc'"
                  (ngModelChange)="itemEdit['value_end_' + functionService.languageTempCode] = $event"
                  (blur)="updateData(dataRow)" [nzAutosize]="{ minRows: 3, maxRows: 15 }"></textarea>
              </div>
            </ng-container>
          </ng-container>
        </nz-modal>

        <!-- Modal Chuyển ảnh lên server -->
        <nz-modal nzTitle="{{ 'chuyen_anh_len_server' | translate}}" [(nzVisible)]="isShowUploadToServer"
          (nzOnCancel)="cancelUploadToServer()" [nzContent]="modalContent" [nzFooter]="modalFooter">
          <ng-template #modalContent>
            <p>{{'nen_anh_tai_len' | translate}}</p>
            <nz-select style="margin-bottom: 15px" [(ngModel)]="compressType"
              nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
              <nz-option [nzValue]="'no-compress'"
                nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
              <nz-option [nzValue]="'compress-frame'"
                nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
              <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
            </nz-select>

            <mat-form-field *ngIf="compressType == 'custom'" class="mr-4">
              <mat-label>{{'chieu_rong' | translate}}</mat-label>
              <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
            </mat-form-field>

            <mat-form-field *ngIf="compressType == 'custom'">
              <mat-label>{{'chieu_cao' | translate}}</mat-label>
              <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
            </mat-form-field>

            <div class="d-flex justify-content-between align-items-center mt-2">
              <span>{{ 'anh_dung_chung_cho_cac_thiet_bi' | translate }}</span>
              <nz-switch [(ngModel)]="isSharedImg"></nz-switch>
            </div>
          </ng-template>
          <ng-template #modalFooter>
            <button nz-button nzType="default" (click)="cancelUploadToServer()">{{'khong' | translate}}</button>
            <button nz-button nzType="primary" (click)="okUploadToServer(itemEdit)"
              [nzLoading]="uploadToServerLoading">{{'dong_y' | translate}}</button>
          </ng-template>
        </nz-modal>
      </tbody>
    </nz-table>
  </div>
</nz-layout>

<!-- ------------------------------------------------- HỘP THOẠI HƯỚNG DẪN CHÈN MAP -------------------------------------------------- -->
<nz-modal [(nzVisible)]="isOpenGuideMap" (nzOnCancel)="isOpenGuideMap = false" [nzFooter]="null"
  [nzStyle]="{ height: '80vh', top: '32px', overflowY : 'scroll'}" [nzWidth]="'70%'">
  <ng-container *nzModalContent>
    <div class="modal-success">
      <h4 class="title">
        {{ 'huong_dan_khach_hang_chen_ban_do_vao_trang_web' | translate }}
      </h4>
      <span>
        <i class="bi bi-x-lg"></i>
      </span>
      <div class="list-image">
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1.jpg" alt="image 1">
          <div class="note-content">
            {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_duong_dan' | translate }} <a href="https://www.google.com/maps"
              target="_blank">https://www.google.com/maps</a>
          </div>
        </div>
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1b2.jpg" alt="image 2">
          <div class="note-content">
            {{ 'buoc' | translate }} 2: {{ 'nhap_dia_chi_ban_muon_chia_se_hoac_chen' | translate }}. {{
            'sau_khi_ban_do_da_chon_chinh_xac_vi_tri_ma_dia_chi_vua_nhap' | translate }},
            <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold">{{ 'nut_chia_se' |
                translate }}.</span></span>
          </div>
        </div>

      </div>
      <div class="list-image pt-3">
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1b3.jpg" alt="image 3">
          <div class="note-content">
            {{ 'buoc' | translate }} 3: {{ 'nhan_vao' | translate }} <span style="color: black">{{ 'tab_nhung_ban_do' |
              translate }}</span>
            <span style="color:#00a859; font-weight: bold;"> & {{ 'nhan_nut_sao_chep_html' | translate }}.</span>
          </div>
        </div>
        <div class="item-image">
          <img src="/assets/root/images/system/imgs/map_b1b4.jpg" alt="image 4">
          <div class="note-content">
            {{ 'buoc' | translate }} 4: <span style="color:#00a859"> {{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' |
              translate }}
              <span style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span> {{
            'de_he_thong_lay_ban_do_ve' | translate }}.
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- ------------------------------------------------- HỘP THOẠI HƯỚNG DẪN CHÈN VIDEO -------------------------------------------------- -->
<nz-modal [(nzVisible)]="isOpenGuideVideo" (nzOnCancel)="isOpenGuideVideo = false" [nzFooter]="null"
  [nzStyle]="{ height: '500px', top: ' 10px' }" [nzWidth]="'70%'">
  <ng-container *nzModalContent>
    <div class="modal-success">
      <nz-tabset>
        <nz-tab nzTitle="Youtube">
          <h4 class="title">
            {{'huong_dan_khach_hang_chen_video_youtube_vao_trang_web' | translate}}
          </h4>
          <span>
            <i class="bi bi-x-lg"></i>
          </span>
          <div class="list-image">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_B1.jpg" alt="image 1">
              <div class="note-content">
                {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_youtube_muon_chen_sau_do' | translate }}
                <span style="color:#00a859"> {{ 'nhan_vao' | translate }}
                  <span style="font-weight: bold;"> {{ 'nut' | translate}} Share</span>
                </span> {{ 'o_duoi_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_b2.jpg" alt="image_2">
              <div class="note-content">
                {{ 'buoc' | translate }} 2:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{ 'nut' |
                    translate}} Embed</span></span>
                {{ 'de_lay_ma_nhung' | translate }}.
              </div>
            </div>

          </div>
          <div class="list-image pt-2">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_b3.jpg" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 3:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{ 'nut' |
                    translate}} Copy</span></span>,
                {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 4:
                <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }}
                  <span style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span>
                </span> {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
              </div>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Tiktok">
          <h4 class="title">
            {{'huong_dan_khach_hang_chen_video_tiktok_vao_trang_web' | translate}}
          </h4>
          <div class="list-image">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_tiktok_b1.png" alt="image 1">
              <div class="note-content">
                {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_tiktok_muon_chen_sau_do' | translate }}
                <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Share</span></span>
                {{ 'o_duoi_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_tiktok_b2.png" alt="image_2">
              <div class="note-content">
                {{ 'buoc' | translate }} 2:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Embed</span></span>
                {{ 'de_lay_ma_nhung' | translate }}.
              </div>
            </div>
          </div>
          <div class="list-image pt-2">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_tiktok_b3.png" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 3:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Copy</span></span>,
                {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 4:
                <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
              </div>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Facebook">
          <h4 class="title">
            {{'huong_dan_khach_hang_chen_video_facebook_vao_trang_web' | translate}}
          </h4>
          <div class="list-image">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_facebook_b1.png" alt="image 1">
              <div class="note-content">
                {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_facebook_muon_chen_sau_do' | translate }}
                <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Share</span></span>
                {{ 'o_duoi_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_facebook_b2.png" alt="image_2">
              <div class="note-content">
                {{ 'buoc' | translate }} 2:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Embed</span></span>
                {{ 'de_lay_ma_nhung' | translate }}.
              </div>
            </div>
          </div>
          <div class="list-image pt-2">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_facebook_b3.png" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 3:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Copy</span></span>,
                {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 4:
                <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
              </div>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Instagram">
          <h4 class="title">
            {{'huong_dan_khach_hang_chen_video_instagram_vao_trang_web' | translate}}
          </h4>
          <div class="list-image">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_instagram_b1.png" alt="image 1">
              <div class="note-content">
                {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_instagram_muon_chen_sau_do' | translate }}
                <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Share</span></span>
                {{ 'o_duoi_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_instagram_b2.png" alt="image_2">
              <div class="note-content">
                {{ 'buoc' | translate }} 2:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Embed</span></span>
                {{ 'de_lay_ma_nhung' | translate }}.
              </div>
            </div>
          </div>
          <div class="list-image pt-2">
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_instagram_b3.png" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 3:
                <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                    'nut' | translate}} Copy</span></span>,
                {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
              </div>
            </div>
            <div class="item-image">
              <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
              <div class="note-content">
                {{ 'buoc' | translate }} 4:
                <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
              </div>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </ng-container>
</nz-modal>

<ng-template #tooltipImgInfo>
  <div class="my-1 img-info">
    <p class="img-info__text">
      {{ 'thu_muc_chua_tep_hinh_anh' | translate }}:
    </p>
    <p class="img-info__text highlight ml-2">
      {{ getFileInfo(itemEdit[deviceTemp + '_value']).folderPath }}
    </p>
    <p class="img-info__text mt-1">
      {{ 'ten_tep_hinh_anh' | translate }}:
    </p>
    <p class="img-info__text highlight ml-2">
      {{ getFileInfo(itemEdit[deviceTemp + '_value']).fullFileName }}
    </p>
  </div>
  <button class="w-100 my-1" nz-button nzType="default" style="padding: 4px 6px;"
    (click)="copyLinkImg(itemEdit[deviceTemp + '_value'])">
    {{'nhan_de_sao_chep_duong_dan_anh' | translate}}
  </button>
</ng-template>

<!-- TEMPLATE: Nút dịch -->
<ng-template #btnTranslateTemp let-dataKey="dataKey" let-itemEdit="itemEdit" 
  let-dataRow="dataRow">
  <button 
    *ngIf="isAutoTranslate && functionService.multi_languages.length > 1"
    class="_btn _btn_add d-flex align-items-center right-all-content mr-2" 
    nz-button nzType="primary" (click)="autoTranslateLang(dataKey, itemEdit, dataRow)" 
    [disabled]="!itemEdit[dataKey + '_' + functionService.languageTempCode]"
    [ngStyle]="{opacity: !itemEdit[dataKey + '_' + functionService.languageTempCode] ? .5: 1}"
    style="padding: 4px 8px;">
    {{'dich' | translate}}
  </button>
</ng-template>